// src/app/state/app-state.service.ts

import {
  Injectable,
  inject,
  signal,
  effect,
  computed,
  EffectRef,
} from '@angular/core';
import { AppState } from './app-state.model';
import { INITIAL_APP_STATE } from './app-state.token';
import { loadState, saveState } from './app-state.utils';

@Injectable({ providedIn: 'root' })
export class AppStateService {
  private readonly initialState = inject(INITIAL_APP_STATE);
  private readonly _state = signal<AppState>(this.initialState);
  private effectCleanup?: EffectRef;

  readonly state = this._state.asReadonly();

  constructor() {
    // Don't create effect in constructor - will be created after init
  }

  // Load from localStorage (can be async if needed)
  init(): void {
    const stored = loadState();
    if (stored) {
      this._state.set(stored);
    }

    // Create effect after loading stored state
    this.effectCleanup = effect(() => {
      const currentState = this._state();
      saveState(currentState);
    });
  }

  updateState(partial: Partial<AppState>) {
    this._state.update((prev) => {
      const newState = { ...prev, ...partial };
      return newState;
    });
  }

  reset() {
    this._state.set(this.initialState);
  }

  setToken(accessToken: string | null) {
    this.updateState({ accessToken });
  }

  // Manual save for debugging
  manualSave() {
    saveState(this._state());
  }
}
